import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import { getHeader } from '../util/axios_helper'
import { requests } from '.'

// getAxiosInterceptor

// import firebase from 'firebase/compat/app'
// import { getJWT } from '../util/jwt_helper'

// Configure request setup
const serviceName = 'PerformanceMonitoringService'
const host = servicesConfig.PerformanceMonitoringService as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

let frontendTokenLogSent = false

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Determine if we should use sendBeacon
const sendBeaconRequest = host.includes('/_pm')

// Helper function to send beacon
const sendBeacon = (url: string, data: any) => {
  if (!navigator.sendBeacon) {
    console.warn('[Perf] SendBeacon not supported in this browser')
    return false
  }

  try {
    const payload = JSON.stringify({
      data,
      headers: getHeader(),
    })

    // Check payload size (64KB = 65536 bytes)
    if (payload.length > 65536) {
      console.warn('[Perf] Payload too large for sendBeacon:', payload.length, 'bytes')
      return false
    }

    const blob = new Blob([payload], {
      type: 'text/plain;charset=UTF-8',
    })
    return navigator.sendBeacon(url, blob)
  } catch (error) {
    console.error('[Perf] Failed to send beacon:', error)
    return false
  }
}

// Define service object with methods
const PerformanceMonitoringService = {
  monitoringPerformance: (body: any) => {
    if (process.env.NODE_ENV?.toLowerCase() === 'beta') {
      return
    }

    if (sendBeaconRequest) {
      sendBeacon(`${host}/1/route-change-logs`, body) //new index
      return
    }
    request()
      .post('/1/route-change-logs', body)
      .catch(error => {
        console.error('[Perf] Failed to send route change logs request:', error)
      })
  },

  logFirestorePerformance: async (body: any) => {
    if (sendBeaconRequest) {
      sendBeacon(`${host}/1/firestore-logs`, body)
      return
    }
    request()
      .post('/1/firestore-logs', body)
      .catch(error => {
        console.error('[Perf] Failed to send firestore logs request:', error)
      })
  },

  logFrontendTokenLogs: async (body: any) => {
    if (frontendTokenLogSent) {
      return
    }
    frontendTokenLogSent = true
    if (sendBeaconRequest) {
      sendBeacon(`${host}/1/frontend-token-logs`, body)
      return
    }
    request()
      .post(`/1/frontend-token-logs`, body)
      .catch(error => {
        console.error('[Perf] Failed to send frontend logout request:', error)
      })
    setTimeout(
      () => {
        frontendTokenLogSent = false
      },
      60 * 60 * 1000
    ) // 1 hour
  },

  logOperationExecutorMetrics: (body: any) => {
    sendBeacon(`${host}/1/operation-executor-logs`, body)
  },

  logPromiseExecutorMetrics: (body: any) => {
    sendBeacon(`${host}/1/promise-executor-logs`, body)
  },

  /**
   * Log slow or large resource (JS, CSS, API, etc.)
   * Triggered when: duration >1s OR size >500KB (assets) / >50KB (API)
   */
  logResourcePerformance: (body: any) => {
    sendBeacon(`${host}/1/resource-performance-logs`, body)
  },

  /**
   * Log page load report when load time >5s
   * Includes: slowResources, largeResources, totalLoadTime
   */
  logPageLoadPerformance: (body: any) => {
    sendBeacon(`${host}/1/page-load-performance-logs`, body)
  },
}

export default PerformanceMonitoringService
